import type { ScheduleLegInput, VehicleChainAssignment, ScheduleAssignmentCheck } from './types';

/** Each job may appear on at most one vehicle chain. */
export function findDuplicateJobAssignments(
  chains: VehicleChainAssignment[]
): ScheduleAssignmentCheck['duplicateJobs'] {
  const jobToVehicles = new Map<string, Set<string>>();

  for (const chain of chains) {
    for (const leg of chain.legs) {
      if (!jobToVehicles.has(leg.jobId)) {
        jobToVehicles.set(leg.jobId, new Set());
      }
      jobToVehicles.get(leg.jobId)!.add(chain.vehicleId);
    }
  }

  const duplicateJobs: ScheduleAssignmentCheck['duplicateJobs'] = [];
  for (const [jobId, vehicleIds] of jobToVehicles) {
    if (vehicleIds.size > 1) {
      duplicateJobs.push({ jobId, vehicleIds: [...vehicleIds] });
    }
  }
  return duplicateJobs;
}

export function findUnassignedJobs(
  allJobIds: string[],
  chains: VehicleChainAssignment[]
): string[] {
  const assigned = new Set<string>();
  for (const chain of chains) {
    for (const leg of chain.legs) {
      assigned.add(leg.jobId);
    }
  }
  return allJobIds.filter((id) => !assigned.has(id));
}

export function checkScheduleAssignments(
  allJobIds: string[],
  chains: VehicleChainAssignment[]
): ScheduleAssignmentCheck {
  return {
    duplicateJobs: findDuplicateJobAssignments(chains),
    unassignedJobIds: findUnassignedJobs(allJobIds, chains),
  };
}

export function collectLegJobIds(legs: ScheduleLegInput[]): string[] {
  return [...new Set(legs.map((l) => l.jobId))];
}
